import React from 'react';
import '../../../../Veridas/SuccessValidation/SuccessValidationForm.scss';
import SuccessfullyRegisteredVeridas from "./SuccessfullyRegisteredVeridas";
import ContainerValidation from "../../../Visitor/External/Components/ContainerValidation";
import HeaderValidation from "../../../Visitor/External/Components/HeaderValidation";
import BodyValidation from "../../../Visitor/External/Components/BodyValidation";
import EventSuccessValidationFormApp from "../Functionality/EventSuccessValidationFormApp";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 */
const EventSuccessValidationForm = () => {

    const {
        t,
        modifiedData,
        activeStep,
        handleSubmit
    } = EventSuccessValidationFormApp();

    return (
        <>
            <ContainerValidation>
                <HeaderValidation
                    activeStep={activeStep}
                    steps={3}
                    showBtnBack={false}
                    headerCenter={
                        <div className="d-flex flex-column flex-sm-row justify-content-center align-items-center align-self-center gap-1">
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 text-center">{t("identity_validation_title")}</p>
                            <p className="fs-16-to-14 ibl-font-w-600 font-color-general-950 d-none d-sm-block">{"•"}</p>
                            <p className="fs-16-to-12 ibl-font-w-400 font-color-general-950 text-center">{`${t("step")} ${activeStep} ${t("of")} ${2} `}</p>
                        </div>
                    }
                />

                <BodyValidation
                    click={() => {
                        handleSubmit();
                    }}
                    showBtnNext={true}
                    classWith="content-center-w-600px gap-1"
                    btnDisabled={false}
                    textBtnNext={'exit'}
                >
                    <div className="w-100">
                        <SuccessfullyRegisteredVeridas
                            data={modifiedData}
                        />
                    </div>
                </BodyValidation>
            </ContainerValidation>
        </>
    );
};
export default EventSuccessValidationForm;
